export const LOAD_GAME = 'LOAD_GAME';
export const EXIT_GAME = 'EXIT_GAME';
export const OPEN_MENU = 'OPEN_MENU';
export const CLOSE_MENU = 'CLOSE_MENU';
export const OPEN_TUTORIAL = 'OPEN_TUTORIAL';
export const CLOSE_TUTORIAL = 'CLOSE_TUTORIAL';
export const START_GAME = 'START_GAME';
export const END_GAME = 'END_GAME'; 


export const UPDATE_DATA  = 'UPDATE_DATA';


export const START_NEW_GAME = 'START_NEW_GAME';
export const SYNC_USER_INPUT = 'SYNC_USER_INPUT';
export const NEXT_WORD = 'NEXT_WORD';
export const SET_HINT = 'SET_HINT';
export const UNDO = 'UNDO'
export const STOP_THIS_GAME = 'STOP_THIS_GAME'